// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-IBcgzLpI","mainContent":"dp-t6rg1DzU","title":"dp-1ogZoxTF","inputContainer":"dp-9ZtXrFxb","searchBtn":"dp-9bnksiv2"};